var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContainer flexCenter",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"flexCloumnCenter",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":require("../../public/img/web_default.png"),"alt":""}}),_c('div',{},[_vm._v(" 敬请期待 ")])])])
}]

export { render, staticRenderFns }